import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id AB147073-9D20-4DA1-A108-3856FC1764C1
 * name tune-vertical
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tune-vertical.svg
 * tags
 * - Settings 
 * - Audio 
 */
export const TuneVerticalIcon = createSvgIcon(<><path d="M7 3H5V9H7V3M19 3H17V13H19V3M3 13H5V21H7V13H9V11H3V13M15 7H13V3H11V7H9V9H15V7M11 21H13V11H11V21M15 15V17H17V21H19V17H21V15H15Z" /></>, 'TuneVerticalIcon');
export default TuneVerticalIcon